/**
 * @generated SignedSource<<8879c34b33ac39d57518dc59b6e400b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectEmbedQuery$variables = {
  id: string;
  isSpecificUpdate: boolean;
  key: string;
};
export type ProjectEmbedQuery$data = {
  readonly projectByKey?: {
    readonly updates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedUpdate">;
        } | null;
      } | null> | null;
    } | null;
    readonly workspace: {
      readonly uuid: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedAbout" | "ProjectEmbedRow">;
  } | null;
  readonly projectUpdate?: {
    readonly project: {
      readonly workspace: {
        readonly uuid: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedAbout" | "ProjectEmbedRow">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedUpdate">;
  } | null;
};
export type ProjectEmbedQuery = {
  response: ProjectEmbedQuery$data;
  variables: ProjectEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSpecificUpdate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v4 = {
  "kind": "FragmentSpread",
  "name": "ProjectEmbedAbout"
},
v5 = {
  "kind": "FragmentSpread",
  "name": "ProjectEmbedRow"
},
v6 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v7 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ]
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v9 = {
  "kind": "FragmentSpread",
  "name": "ProjectEmbedUpdate"
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "picture"
},
v13 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v14 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        },
        (v13/*: any*/)
      ]
    },
    (v14/*: any*/),
    (v15/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "theMeasurement"
},
v18 = {
  "kind": "ScalarField",
  "name": "theWhat"
},
v19 = {
  "kind": "ScalarField",
  "name": "theWhy"
},
v20 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v15/*: any*/)
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "key"
},
v22 = {
  "kind": "ScalarField",
  "name": "private"
},
v23 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "label"
},
v25 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v26 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v25/*: any*/)
},
v27 = [
  (v24/*: any*/),
  (v26/*: any*/),
  {
    "alias": "projectStateValue",
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "concreteType": "CompletionProjectState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "value"
      },
      (v24/*: any*/),
      (v26/*: any*/)
    ]
  }
],
v28 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v30 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v24/*: any*/),
  (v26/*: any*/),
  {
    "alias": "tooltip",
    "args": (v29/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v29/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v25/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v31 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "ScalarField",
  "name": "summary"
},
v33 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v34 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v35 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v36 = {
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "members",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v15/*: any*/)
          ]
        }
      ]
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "title"
},
v38 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "archived"
    },
    (v37/*: any*/),
    (v32/*: any*/),
    (v15/*: any*/)
  ]
},
v39 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v30/*: any*/)
},
v40 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v30/*: any*/)
},
v41 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v27/*: any*/)
},
v42 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "oldState",
  "plural": false,
  "selections": (v27/*: any*/)
},
v43 = {
  "kind": "ScalarField",
  "name": "ari"
},
v44 = [
  (v21/*: any*/),
  (v43/*: any*/),
  (v15/*: any*/)
],
v45 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ]
  },
  (v14/*: any*/),
  (v15/*: any*/)
],
v46 = {
  "concreteType": "LearningConnection",
  "kind": "LinkedField",
  "name": "learnings",
  "plural": false,
  "selections": [
    {
      "concreteType": "LearningEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Learning",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "type"
            },
            (v6/*: any*/),
            (v15/*: any*/),
            (v32/*: any*/),
            {
              "kind": "ScalarField",
              "name": "description"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v43/*: any*/),
                {
                  "concreteType": "Project",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": (v44/*: any*/)
                },
                {
                  "concreteType": "Goal",
                  "kind": "LinkedField",
                  "name": "goal",
                  "plural": false,
                  "selections": (v44/*: any*/)
                },
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "creator",
                  "plural": false,
                  "selections": (v45/*: any*/)
                },
                (v35/*: any*/),
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "lastEditedBy",
                  "plural": false,
                  "selections": (v45/*: any*/)
                },
                {
                  "kind": "ScalarField",
                  "name": "lastEditedDate"
                }
              ],
              "type": "Highlight",
              "abstractKey": "__isHighlight"
            }
          ]
        }
      ]
    }
  ]
},
v47 = {
  "concreteType": "MilestoneConnection",
  "kind": "LinkedField",
  "name": "milestones",
  "plural": false,
  "selections": [
    {
      "concreteType": "MilestoneEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Milestone",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v15/*: any*/),
            (v37/*: any*/),
            {
              "kind": "ScalarField",
              "name": "targetDate"
            },
            {
              "kind": "ScalarField",
              "name": "targetDateType"
            },
            {
              "kind": "ScalarField",
              "name": "status"
            }
          ]
        }
      ]
    }
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v49 = {
  "concreteType": "ProjectChangelogItem",
  "kind": "LinkedField",
  "name": "changelog",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "newValue"
    },
    {
      "kind": "ScalarField",
      "name": "oldValue"
    },
    (v15/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectEmbedQuery",
    "selections": [
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "args": (v8/*: any*/),
                "concreteType": "ProjectUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              }
            ]
          }
        ]
      },
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "projectUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectEmbedQuery",
    "selections": [
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v6/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v15/*: any*/),
              (v11/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v28/*: any*/),
              (v31/*: any*/),
              {
                "args": (v8/*: any*/),
                "concreteType": "ProjectUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v6/*: any*/),
                              (v36/*: any*/),
                              (v20/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v15/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              }
            ]
          }
        ]
      },
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "projectUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v6/*: any*/),
                  (v21/*: any*/),
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v28/*: any*/),
                  (v31/*: any*/),
                  (v36/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v15/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dc8ba72a3385aaaa966eeb42cab3ef43",
    "id": null,
    "metadata": {},
    "name": "ProjectEmbedQuery",
    "operationKind": "query",
    "text": "query ProjectEmbedQuery(\n  $key: String!\n  $id: ID!\n  $isSpecificUpdate: Boolean!\n) {\n  projectByKey(key: $key) @skip(if: $isSpecificUpdate) {\n    ...ProjectEmbedAbout\n    ...ProjectEmbedRow\n    workspace {\n      uuid\n      id\n    }\n    updates(first: 1) {\n      edges {\n        node {\n          ...ProjectEmbedUpdate\n          id\n        }\n      }\n    }\n    id\n  }\n  projectUpdate(id: $id) @include(if: $isSpecificUpdate) {\n    project {\n      workspace {\n        uuid\n        id\n      }\n      ...ProjectEmbedAbout\n      ...ProjectEmbedRow\n      id\n    }\n    ...ProjectEmbedUpdate\n    id\n  }\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissingDetailsPrompt on Project {\n  owner {\n    pii {\n      name\n    }\n    aaid\n    id\n  }\n  key\n  theMeasurement\n  theWhat\n  theWhy\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectEmbedAbout on Project {\n  owner {\n    pii {\n      name\n    }\n    aaid\n    id\n  }\n  theMeasurement\n  theWhat\n  theWhy\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  ...MissingDetailsPrompt\n}\n\nfragment ProjectEmbedRow on Project {\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...ProjectState\n  }\n  dueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectEmbedUpdate on ProjectUpdate {\n  uuid\n  summary\n  missedUpdate\n  updateType\n  creationDate\n  project {\n    key\n    uuid\n    members {\n      ...utils_isUserInList\n    }\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardContentExtras\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newState {\n    ...ProjectState\n  }\n  oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar_1cDMtx on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c0ec8da7bc2b2fa6b1938f9bb5bf704";

export default node;
